import React from 'react';
import styles from '../../App.module.css';
import FooterLinks from '../../components/layout/FooterLinks'; // ✅ New Footer Import
import BurgerHint from '../../components/layout/BurgerHint';   // ✅ Burger Tip!
import ThreeBenefits from '../../components/layout/ThreeBenefits';
// ✅ Correct spelling

const FounderMessage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>A Message from the Founder</h1>
                {/* 🍀 Footer Links */}
                <FooterLinks />
        {/* ✨ Soft "Card" for Founder Note */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.85)',
          border: '1px solid #ddd',
          padding: '1rem',
          borderRadius: '12px',
          margin: '.5rem auto',
          maxWidth: '700px',
          fontFamily: 'Georgia, serif',
          fontSize: '1.1rem',
          lineHeight: '1.6',
          textAlign: 'left',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
        }}>
          <p style={{ fontStyle: 'italic', marginBottom: '1.5rem' }}>
            I built <span style={{ fontWeight: 'bold' }}>d<span style={{ color: '#1d4ed8' }}>AI</span>sy</span> from the ground up — not just as an app, but as a heartfelt companion.
          </p>
          <p style={{ fontStyle: 'italic', marginBottom: '1.5rem' }}>
            She remembers what matters to you, adapts her responses with care, and reflects your journey over time.
          </p>
          <p style={{ fontStyle: 'italic', marginBottom: '2rem' }}>
            Every part of the experience — from her emotional intelligence to her secure, scalable backend — was crafted by one person, with empathy, compassion, and love.
          </p>

          {/* Signature */}
          <p style={{
            fontFamily: '"Pacifico", cursive',
            fontSize: '1.6rem',
            color: '#1d4ed8',
            marginTop: '1rem'
          }}>
            Chris
        {/* 🍔 Burger Menu Tip */}
        <BurgerHint />
        </p>
        </div>
        {/* ✨ Three Benefits Section */}
        <ThreeBenefits />

        {/* 🛠️ Technical Note */}
        <div style={{ marginTop: '2rem' }}>
          <p>
            <strong>For the technical among you</strong><br />
            I engineered the frontend in React, the backend with Node and a simple accounts database,
            added non-human readable vector memory, obfuscated JSON documents, integrated Stripe,
            and built a real-time chat experience that feels alive.
          </p>
          <p style={{ marginTop: '1rem' }}>
            I built this entire system to be a safe, secure, and scalable platform for you to connect with&nbsp;
            <strong>
              <span style={{ color: '#111827' }}>d</span>
              <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
              <span style={{ color: '#111827' }}>sy</span>
            </strong>.
          </p>
          <p style={{ marginTop: '1rem' }}>
            Many more advanced features and refinements are planned and in the works.
            <br />
            Remember,&nbsp;
            <strong>
              <span style={{ color: '#111827' }}>d</span>
              <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
              <span style={{ color: '#111827' }}>sy</span>
            </strong>&nbsp;
            doesn’t just respond.&nbsp;<strong>She cares. 😎</strong>
          </p>
        </div>

        {/* 🍀 Footer Links */}
        <FooterLinks />
      </div>
    </div>
  );
};

export default FounderMessage;
